import { apiSlice } from '../../app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const studentProceedingsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Students'],
  endpoints: (build) => ({
    createStudentProceeding: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    getAllStudentProceedings: build.query({
      query: (payload) => {
        const { page, limitNumber, params = {} } = payload
        const parsedParams = removeEmptyKeys(params)
        return {
          url: `/student/proceeding/${page}/params`,
          params: { limitNumber: limitNumber, ...parsedParams },
        }
      },
      transformResponse: (response) => {
        return {
          rows: response.Proceedings,
          count: response.count,
          page: response.page,
        }
      },
      providesTags: ['Proceedings'],
    }),
    getPendingStudentProceedings: build.query({
      query: (payload) => {
        const { page = 1, pageSize = 50, state = 'p' } = payload
        return {
          url: `/student/proceeding/${page}/params`,
          params: { state, limitNumber: pageSize },
        }
      },
      providesTags: ['Proceedings'],
    }),
    getProceedingDetail: build.query({
      query: (payload) => {
        const { proceedingId } = payload
        return {
          url: `/student/proceeding/${proceedingId}`,
        }
      },
      providesTags: ['Proceedings'],
    }),
    approveAndSendProceedings: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding/',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    approveAndCreditProceedings: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding/aprobal',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    getProceedingsPNR: build.query({
      query: (payload) => {
        const { proceedingid } = payload
        return {
          url: `/student/proceeding/prnfile/`,
          params: { proceedingid: proceedingid },
        }
      },
      providesTags: ['ProceedingsPNR'],
    }),
    updateProceeding: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding/update',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    disableProceeding: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding/disable',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    rejectProceeding: build.mutation({
      query: (payload) => ({
        url: '/student/proceeding/reject',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Students', 'Proceedings'],
    }),
    overrideExisting: true,
  }),

})

export const {
  useCreateStudentProceedingMutation,
  useGetAllStudentProceedingsQuery,
  useGetPendingStudentProceedingsQuery,
  useGetProceedingDetailQuery,
  useApproveAndSendProceedingsMutation,
  useApproveAndCreditProceedingsMutation,
  useGetProceedingsPNRQuery,
  useUpdateProceedingMutation,
  useDisableProceedingMutation,
  useRejectProceedingMutation,
} = studentProceedingsApiSlice
